module.exports = __webpack_public_path__ + "img/logo.47050329.png";